import { Box, Card, Skeleton, useMediaQuery } from "../../imports/muiImport";

function GiftCardSkeleton() {
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Box
      maxWidth="xl"
      sx={{
        width: "100%",
        boxShadow: { xs: 0, sm: 3 },
        borderRadius: 3,
        p: { xs: "12px 8px", sm: "16px 10px" },
      }}
    >
      {/* Heading */}
      <Box
        sx={{
          mb: { xs: 1, sm: 2 },
          display: "flex",
          justifyContent: { xs: "center", sm: "flex-start" },
        }}
      >
        <Skeleton
          animation="wave"
          sx={{
            width: { xs: 160, sm: 300 },
            height: 32,
          }}
        />
      </Box>

      {/* Cards Row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          gap: { xs: "8px", sm: "12px" },
          overflow: "hidden",
        }}
      >
        {Array.from({ length: isMobile ? 2 : 5 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              width: { xs: 160, sm: 261 },
              flexShrink: 0,
            }}
          >
            {/* Image Card */}
            <Card
              sx={{
                width: "100%",
                mb: 0.8,
                borderRadius: "10px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
              }}
            >
              <Skeleton
                variant="rectangular"
                animation="wave"
                width="100%"
                sx={{
                  height: {
                    xs: 130,
                    sm: 140,
                    md: 150,
                    lg: 160,
                  },
                }}
              />
            </Card>

            {/* Name */}
            <Skeleton
              animation="wave"
              sx={{
                width: "75%",
                height: 16,
                ml: 0.75,
              }}
            />

            {/* Discount */}
            <Skeleton
              animation="wave"
              sx={{
                width: "55%",
                height: 14,
                ml: 0.75,
                mt: 0.3,
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default GiftCardSkeleton;